import type { MouseEvent } from "react";
import React from "react";

import { DottySpan, SubmitButton } from "./styles";

export type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  size?: "large" | "medium" | "small";
};

export const SignUpButton: React.FunctionComponent<Props> = ({
  children,
  isLoading,
  onClick,
  size = "medium",
  ...props
}) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (isLoading) return;
    onClick(event);
  };

  return (
    <SubmitButton {...props} $buttonSize={size} onClick={handleClick}>
      {isLoading ? <DottySpan>SENDING</DottySpan> : <span>{children}</span>}
    </SubmitButton>
  );
};

SignUpButton.displayName = "SignUpButton";
